import styled from 'styled-components'
import { breakpoint, Heading4Styles } from '../../layout/mixins'
import DownloadIcon from '../../layout/icons/download.svg'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colorGrey};
  color: ${({ theme }) => theme.colorBlack};
  padding: ${({ theme }) => theme.gutterMedium};
`

export const Heading = styled.h3`
  ${Heading4Styles}
  font-size: ${({ theme }) => theme.fontsizeMedium};
`

export const List = styled.ul`
  margin-top: ${({ theme }) => theme.gutter};
  border-top: 1px solid ${({ theme }) => theme.colorBlack};
`
export const Item = styled.li`
  padding: ${({ theme }) => theme.gutterSmall} 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colorBlack};
`

export const Link = styled.a`
  display: block;
  flex-grow: 1;
  color: ${({ theme }) => theme.colorBlack};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: ${({ theme }) => theme.gutter};
  line-height: 1.3;
`

export const Icon = styled(DownloadIcon)`
  width: 1em;
  height: 1em;
  fill: ${({ theme }) => theme.colorBlack};
  flex: 1 0 1em;
`